export const workConditionsContentSectionsPart1 = [
  {
    titleKey: 'START_YOUR_OWN_BUSINESS_TO_INVOICE',
    textKeys: ['START_YOUR_OWN_BUSINESS_TEXT']
  },
  {
    titleKey: 'UNDERSTANDING_DIFFERENT_BUSINESS_FORMS',
    textKeys: ['UNDERSTANDING_DIFFERENT_BUSINESS_FORMS_TEXT']
  },
];
export const workConditionsContentSectionsPart2 = [
  {
    titleKey: 'INVOICING_WITH_SOLE_PROPRIETORSHIP',
    textKeys: ['INVOICING_WITH_SOLE_PROPRIETORSHIP_TEXT_1', 'INVOICING_WITH_SOLE_PROPRIETORSHIP_TEXT_2', 'INVOICING_WITH_SOLE_PROPRIETORSHIP_TEXT_3']
  },
  {
    titleKey: 'PARTNERSHIP_FOR_TWO_OR_MORE_INDIVIDUALS',
    textKeys: ['PARTNERSHIP_TEXT_1', 'PARTNERSHIP_TEXT_2', 'PARTNERSHIP_TEXT_3']
  },
  {
    titleKey: 'LIMITED_COMPANY_PROVIDES_SUFFICIENT_PROTECTION',
    textKeys: ['LIMITED_COMPANY_TEXT_1', 'LIMITED_COMPANY_TEXT_2', 'LIMITED_COMPANY_TEXT_3']
  },
];
export const workConditionsContentSectionsPart3 = [
  {
    titleKey: 'WHAT_DOES_IT_MEAN_TO_INVOICE_WITHOUT_COMPANY',
    textKeys: ['INVOICE_WITHOUT_COMPANY_TEXT_1', 'INVOICE_WITHOUT_COMPANY_TEXT_2']
  },
  {
    titleKey: 'PROS_AND_CONS_OF_INVOICING_WITHOUT_COMPANY',
    textKeys: ['PROS_AND_CONS_TEXT_1', 'PROS_AND_CONS_TEXT_2', 'PROS_AND_CONS_TEXT_3', 'PROS_AND_CONS_TEXT_4']
  },
];
export const workConditionsContentSectionsPart4 = [
  {
    titleKey: 'HOW_TO_CHOOSE_RIGHT_BUSINESS_STRUCTURE',
    textKeys: ['CHOOSE_BUSINESS_STRUCTURE_TEXT']
  },
  {
    titleKey: 'ASSESSING_YOUR_BUSINESS_NEEDS',
    textKeys: ['ASSESSING_BUSINESS_NEEDS_TEXT_1', 'ASSESSING_BUSINESS_NEEDS_TEXT_2']
  },
  {
    titleKey: 'CONSIDERING_YOUR_PERSONAL_RISK_TOLERANCE',
    textKeys: ['PERSONAL_RISK_TOLERANCE_TEXT_1', 'PERSONAL_RISK_TOLERANCE_TEXT_2']
  },
  {
    titleKey: 'CONSIDER_TAX_CONSEQUENCES',
    textKeys: ['TAX_CONSEQUENCES_TEXT_1', 'TAX_CONSEQUENCES_TEXT_2']
  },
];

export const workConditionsContentSectionsPart5 = [
  {
    titleKey: 'STEPS_TO_START_YOUR_OWN_BUSINESS',
    textKeys: ['STEPS_TO_START_BUSINESS_TEXT']
  },
  {
    titleKey: 'CREATING_A_BUSINESS_PLAN',
    textKeys: ['CREATING_BUSINESS_PLAN_TEXT_1', 'CREATING_BUSINESS_PLAN_TEXT_2']
  },
  {
    titleKey: 'REGISTERING_YOUR_BUSINESS',
    textKeys: ['REGISTERING_BUSINESS_TEXT_1', 'REGISTERING_BUSINESS_TEXT_2']
  },
  {
    titleKey: 'FINANCING_YOUR_BUSINESS',
    textKeys: ['FINANCING_BUSINESS_TEXT_1', 'FINANCING_BUSINESS_TEXT_2', 'FINANCING_BUSINESS_TEXT_3']
  }
]